import UsuarioEgreenPage from './UsuarioEgreenPage';

export default UsuarioEgreenPage;
